import React from 'react';
import './TextField.css'; // Reusing same CSS if styling matches
import { svgIcons } from '../../../style/fonts/SvgIcons';

interface TextAreaFieldProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    label?: string;
    leftLabel?: string;
    labelClass?: string;
    fieldClass?: string;
    required?: boolean;
    icon?: any;
    fieldIcon?: boolean;
    class?: any;
}

const TextAreaField: React.FC<TextAreaFieldProps> = ({
    label,
    leftLabel,
    labelClass = '',
    id,
    value,
    placeholder,
    onChange,
    required,
    icon,
    fieldIcon,
    fieldClass = '',
    ...fieldProps
}) => {
    return (
        <div className={`${leftLabel ? 'd-md-flex w-100 justify-content-between align-items-start ' : ''}`}>
            {label || leftLabel ? (
                <label className={`input-label text-nowrap ${labelClass} ${required ? 'required' : ''} ${leftLabel ? 'w-50' : ''}`}>
                    <div>
                        <span>{icon}</span> {label}{leftLabel}
                        {required && <span className="required-star text-danger ms-1">*</span>}
                    </div>
                </label>
            ) : null}

            <div className={`position-relative ${leftLabel ? 'w-50' : ''}`}>
                {fieldIcon &&
                    <i className='icon2 position-absolute ms-2' style={{ top: '10px' }}>{svgIcons.dollarIcon}</i>
                }
                <textarea
                    className={`form-control form-control-solid  ${fieldIcon ? 'ps-4' : ''} ${fieldClass}`}
                    placeholder={placeholder}
                    onChange={onChange}
                    id={id}
                    value={value}
                    {...fieldProps}
                    rows={4}
                />
            </div>
        </div>
    );
};

export default TextAreaField;
